import { FC, useState } from "react";
import ModalHeading from "./ModalHeading";
import { useQuery } from "@tanstack/react-query";
import {
  Button,
  Checkbox,
  Collapse,
  Input,
  QRCode,
  Select,
  Spin,
  Switch,
  message,
} from "antd";

import { IoCopyOutline, IoEyeOutline } from "react-icons/io5";
import { RiLinkM } from "react-icons/ri";
import { AiOutlineGlobal } from "react-icons/ai";
import { useIntl } from "react-intl";

import { location } from "../../../../../types/calendar";
import { queryKeys } from "../../../../../services/react-query/queryKeys";
import { getAllPackagesWithCategories } from "../../../../../network/package";
import { NewServices } from "../../../../../types/service";
import { servicesRollSVG } from "../../../../../assets/SVGs/SVGs";
import { Package } from "../../../../../types/package";
import PackagesSVG from "../../../../../assets/catalog/PackagesSVG";
import {
  adminGetPackagesWithCategories,
  getServicesWithCategoriesAdmin,
} from "../../../../../network/admin";
interface ServicesModalWrapperProps {
  handleCreateLink: (params: any) => Promise<void>;
  handleRemoveLink: (params: any) => Promise<void>;
  isLoading: boolean;
  locationLinksData: location;
}

const downloadQRCode = () => {
  const canvas = document
    .getElementById("myqrcode")
    ?.querySelector<HTMLCanvasElement>("canvas");
  if (canvas) {
    const url = canvas.toDataURL();
    const a = document.createElement("a");
    a.download = "QRCode.png";
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};
const ServicesModalWrapper: FC<ServicesModalWrapperProps> = ({
  handleCreateLink,
  handleRemoveLink,
  isLoading,
  locationLinksData,
}) => {
  const intl = useIntl();
  const domain = window.location.origin;

  const [servicesSearch, setServicesSearch] = useState("");
  const [packagesSearch, setPackagesSearch] = useState("");

  const { data: servicesAndCategories, isLoading: fetchingServices } = useQuery(
    ["categories-services", locationLinksData?.id, servicesSearch],
    () =>
      getServicesWithCategoriesAdmin({
        with_parent: 1,
        with_location_services: locationLinksData?.id,
        "location_ids[0]": locationLinksData?.id,
        search: servicesSearch,
      }),
    {
      enabled: !!locationLinksData?.id,
      select: (res) => res?.data,
    }
  );
  const { data: packagesList, isLoading: packagesLoading } = useQuery(
    [queryKeys.listPackages, locationLinksData?.id, packagesSearch],
    () =>
      adminGetPackagesWithCategories(locationLinksData?.id, {
        search: packagesSearch,
      }),
    {
      enabled: !!locationLinksData?.id,
      select: (res) => {
        const data: any[] = [];
        res?.data?.map((category: { services: any[]; packages: any[] }) => {
          if (category?.packages?.length > 0) {
            data.push(category);
          }
        });
        return data;
      },
    }
  );
  const [services, setServices] = useState<number[]>([]);
  const [packages, setPackages] = useState<number[]>([]);

  const submitCatalog = () => {
    handleCreateLink({
      links: [
        {
          link_type: "service_link",
          value: 1,
          services,
          packages,
        },
      ],
    });
    setServices([]);
    setPackages([]);
  };
  return (
    <div>
      {locationLinksData?.have_service_link ? (
        <div>
          <div className="p-4 space-y-4">
            <ModalHeading
              title={intl.formatMessage({ id: "ready_link_title" })}
              description={intl.formatMessage({
                id: "linkCreationDescription",
              })}
            />
            <div className="space-y-3">
              <div className="p-5  flex items-center justify-between gap-2 rounded h-16 bg-[#EEF0FF]">
                <Button
                  type="link"
                  htmlType="button"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      domain + "/" + locationLinksData?.slug
                    );
                    intl.formatMessage({ id: "copy_link_success" });
                  }}
                >
                  <IoCopyOutline size={20} color="#9999A7" />
                </Button>
                <div className="flex items-center justify-between gap-4 h-full">
                  <p className="text-color-primary  ">
                    {domain + "/" + locationLinksData?.slug}
                  </p>
                  <RiLinkM size={18} color="#7FE1C2" />
                </div>
              </div>
              <p className="text-color-sec-title text-center">
                {intl.formatMessage({ id: "copy_code_click" })}
              </p>
            </div>
            <div
              id="myqrcode"
              className="mx-auto flex flex-col justify-center items-center py-2 px-4 rounded bg-[#EEF0FF] w-fit"
            >
              <QRCode
                value={domain + "/" + locationLinksData?.slug}
                bgColor="#EEF0FF"
                color="#00086D"
              />
              <Button
                type="text"
                className="text-color-primary font-semibold"
                onClick={downloadQRCode}
              >
                {intl.formatMessage({ id: "downloadButton" })}
              </Button>
            </div>
            <div className="flex justify-between ">
              <div>
                <p className="px-2 flex items-center gap-2 ">
                  <AiOutlineGlobal color="#7FE1C2" />
                  <span className="text-color-sec-title">
                    {" "}
                    {intl.formatMessage({ id: "activateLink" })}
                  </span>
                </p>
              </div>
              <div>
                <Switch
                  defaultChecked
                  checkedChildren={intl.formatMessage({ id: "activated" })}
                  unCheckedChildren={intl.formatMessage({ id: "deactivated" })}
                  size="default"
                  onChange={(e) => {
                    if (e === true) {
                      submitCatalog();
                    } else {
                      handleRemoveLink({
                        links: [
                          {
                            link_type: "service_link",
                            value: 0,
                          },
                        ],
                      });
                    }
                    setServices([]);
                    message.success(
                      intl.formatMessage({
                        id: e ? "activated" : "deactivated",
                      })
                    );
                  }}
                />
              </div>
            </div>
            <div className="flex justify-center">
              <a href={domain + "/" + locationLinksData?.slug} target="_blank">
                <p className="px-2 flex items-center gap-2 h-8">
                  <IoEyeOutline color="#7FE1C2" />
                  <span className="text-color-primary">
                    {" "}
                    {intl.formatMessage({ id: "viewLink" })}
                  </span>
                </p>
              </a>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="p-4 space-y-4">
            <ModalHeading
              title={intl.formatMessage({ id: "createServiceLinkTitle" })}
              description={intl.formatMessage({
                id: "createServiceLinkDescription",
              })}
            />
            <div className="max-h-[400px] overflow-y-auto bg-[#FBFBFF] p-2 rounded">
              <div>
                <div className="my-2 ">
                  <Input
                    className="w-full"
                    onChange={(value) => {
                      setServicesSearch(value.target.value);
                    }}
                    placeholder={intl.formatMessage({
                      id: "searchServicePlaceholder",
                    })}
                  />
                </div>
                <div>
                  <p>
                    ({services?.length}){" "}
                    {intl.formatMessage({
                      id: "services",
                    })}
                  </p>
                </div>
                {fetchingServices ? (
                  <div className="flex justify-center">
                    <Spin size="large" />
                  </div>
                ) : (
                  <div className="flex flex-col gap-2 max-h-[300px] overflow-auto">
                    {servicesAndCategories?.map(
                      (category: {
                        id: number;
                        name: string;
                        services: NewServices[];
                      }) => (
                        <div key={category?.id}>
                          <h4 className="my-2">{category?.name}</h4>
                          <Collapse
                            size="small"
                            className="bg-[#FBFBFF] border-0"
                            items={[
                              {
                                key: category?.id,
                                label: category?.name,
                                children: (
                                  <div className="">
                                    {category?.services?.map((service) => (
                                      <Checkbox
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setServices([
                                              ...services,
                                              service?.id,
                                            ]);
                                          } else {
                                            setServices(
                                              services.filter(
                                                (item) => item !== service?.id
                                              )
                                            );
                                          }
                                        }}
                                        key={service?.id}
                                        className="w-full bg-[#FBFBFF] "
                                      >
                                        <div
                                          className="flex p-1 gap-2 items-center h-10 text-sm bg-white rounded w-[380px]  my-1 rounded "
                                          key={service?.id}
                                        >
                                          <p>{servicesRollSVG}</p>
                                          <p>{service?.name}</p>
                                        </div>
                                      </Checkbox>
                                    ))}
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="max-h-[400px] overflow-y-auto bg-[#FBFBFF] p-2 rounded">
              <div>
                <div className="my-2 ">
                  <Input
                    className="w-full"
                    onChange={(value) => {
                      setPackagesSearch(value.target.value);
                    }}
                    placeholder={intl.formatMessage({
                      id: "searchPackages",
                    })}
                  />
                </div>
                <div>
                  <p>
                    ({packages?.length}){" "}
                    {intl.formatMessage({
                      id: "packages",
                    })}
                  </p>
                </div>
                {packagesLoading ? (
                  <div className="flex justify-center">
                    <Spin size="large" />
                  </div>
                ) : (
                  <div className="flex flex-col gap-2 max-h-[300px] overflow-auto">
                    {packagesList?.map(
                      (category: {
                        id: number;
                        name: string;
                        packages: Package[];
                      }) => (
                        <div key={category?.id}>
                          <h4 className="my-2">{category?.name}</h4>
                          <Collapse
                            size="small"
                            className="bg-[#FBFBFF] border-0"
                            items={[
                              {
                                key: category?.id,
                                label: category?.name,
                                children: (
                                  <div className="">
                                    {category?.packages?.map((pkg) => (
                                      <Checkbox
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setPackages([...packages, pkg?.id]);
                                          } else {
                                            setPackages(
                                              packages.filter(
                                                (item) => item !== pkg?.id
                                              )
                                            );
                                          }
                                        }}
                                        key={pkg?.id}
                                        className="w-full bg-[#FBFBFF] "
                                      >
                                        <div
                                          className="flex p-1 gap-2 items-center h-10 text-sm bg-white rounded w-[380px]  my-1 rounded "
                                          key={pkg?.id}
                                        >
                                          <PackagesSVG />
                                          <p>{pkg?.name}</p>
                                        </div>
                                      </Checkbox>
                                    ))}
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
            </div>

            <div>
              <Button
                disabled={services.length === 0 && packages.length === 0}
                type="primary"
                htmlType="button"
                block
                onClick={submitCatalog}
                loading={isLoading}
              >
                {intl.formatMessage({
                  id: "confirm",
                })}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicesModalWrapper;
